import { Layout } from '~/layouts/default'
import { GetServerSideProps } from 'next'
import { Collapse } from 'antd'
import { GlobalRequest } from '~/components/global-requset'
import React, { useState } from 'react'
import { SEOHead } from '~/components/business/SEOHead'
import { MyContainer } from '~/components/ui/MyContainer'
import styles from './index.module.css'
import classNames from 'classnames'
import { CDNImage } from '~/components/business/CDNImage'
import SubmitFormModal from '~/components/pages/enterprise-service/SubmitFormModal'
import { ENTERPRISE_CATEGORY_LIST } from '~/graphqls/gqls'
import {
  enterpriseCategoryList,
  enterpriseCategoryList_itemModule_list,
} from '~/graphqls/types'
import {
  qaList,
  funcList,
  advantageList,
} from '~/components/pages/enterprise-service/const'
import Link from 'next/link'
import { toCDNImage } from '~/utils'

const { Panel } = Collapse

const EnterPriseService: React.FC<{
  industryList: enterpriseCategoryList_itemModule_list[]
}> = ({ industryList }) => {
  const [visible, setVisible] = useState(false)
  return (
    <Layout>
      <SEOHead title="企业服务" />
      <div
        className={styles.bgWrapper}
        style={{
          backgroundImage: `url(${toCDNImage(
            '/images/enterprise-service/header/bg.png'
          )})`,
        }}
      >
        <MyContainer className="flex items-center justify-center h-full">
          <div className="text-neutral-900 font-semibold">
            <div className="text-[48px]">无界AI 企业服务开放平台</div>
            <div className="text-[24px] font-semibold">
              一站式<span className="text-primary">产品、模型、算力</span>
              企业解决方案
            </div>
            <div className="mt-[48px] flex">
              <div
                className={classNames(styles.btn, styles.consultBtn)}
                onClick={() => setVisible(true)}
              >
                服务咨询
              </div>
              <Link
                href={'https://torna.wujiebantu.com/#/share/57zLZ8Qw/je24lx2L'}
                target="_blank"
              >
                <div className={classNames(styles.btn, styles.docBtn)}>
                  API文档
                </div>
              </Link>
            </div>
          </div>
          <div className={styles.imgsWrap}>
            <CDNImage
              src="/images/enterprise-service/header/mac.png"
              className={styles.mac}
              alt=""
            />
            <CDNImage
              src="/images/enterprise-service/header/document.png"
              className={styles.document}
              alt=""
            />
            <CDNImage
              src="/images/enterprise-service/header/folder.png"
              className={styles.folder}
              alt=""
            />
            <CDNImage
              src="/images/enterprise-service/header/mouse.png"
              className={styles.mouse}
              alt=""
            />
          </div>
        </MyContainer>
      </div>
      <MyContainer>
        <div className="mt-[96px] mx-[72px]">
          <CDNImage
            src="/images/enterprise-service/title/1.png"
            alt=""
            className="w-full mb-[48px]"
          />
          <div className={styles.funcContent}>
            {funcList.map((it, i) => (
              <div className={classNames(styles.item)} key={it.key}>
                <div className={styles.title}>{it.title}</div>
                <CDNImage src={it.url} alt="" className={styles.image} />
                <div className={styles.triangle}></div>
              </div>
            ))}
          </div>
        </div>
        <div className="my-[72px] mx-[72px]">
          <CDNImage
            src="/images/enterprise-service/title/2.png"
            alt=""
            className="w-full mb-[48px]"
          />
          <div className="flex flex-wrap justify-between relative">
            {advantageList.map((it, i) => (
              <div
                className={classNames(
                  'w-[400px] py-6 rounded-[24px] bg-[#1F1F1F] flex flex-col items-center mb-6',
                  {
                    ['!w-[612px]']: i === 3 || i === 4,
                  }
                )}
                key={it.key}
              >
                <div className="text-[24px] font-semibold text-neutral-900">
                  {it.title}
                </div>
                <div
                  className="w-6 h-1 rounded-[16px] my-4"
                  style={{ background: it.bgColor }}
                />
                <div
                  className="text-center text-sm text-white text-opacity-[0.65]"
                  dangerouslySetInnerHTML={{ __html: it.desc }}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="mx-[72px] mb-[97px] relative">
          <CDNImage
            src="/images/enterprise-service/title/3.png"
            alt=""
            className="w-full"
          />
          <div className={styles.collapse}>
            <Collapse
              bordered={false}
              expandIconPosition="end"
              className="w-[928px]"
              accordion
            >
              {qaList.map(it => (
                <Panel key={it.key} header={it.title}>
                  <div
                    className="text-base leading-[32px] text-white text-opacity-[0.65]"
                    dangerouslySetInnerHTML={{ __html: it.desc }}
                  />
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      </MyContainer>
      <SubmitFormModal
        visible={visible}
        setVisible={setVisible}
        industryList={industryList}
      />
    </Layout>
  )
}

export default EnterPriseService

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)
  const res = await client.query<enterpriseCategoryList>({
    query: ENTERPRISE_CATEGORY_LIST,
    fetchPolicy: 'no-cache',
  })

  return {
    props: {
      initialState,
      industryList: res.data.itemModule?.list || [],
    },
  }
}
